export const countryOptions = [
  {
    key: "Select country",
    value: "",
  },
  {
    key: "China",
    value: "China",
  },
  {
    key: "United States",
    value: "United States",
  },
  {
    key: "Indonesia",
    value: "Indonesia",
  },
  {
    key: "Brazil",
    value: "Brazil",
  },
  {
    key: "Pakistan",
    value: "Pakistan",
  },
  {
    key: "Nigeria",
    value: "Nigeria",
  },
  {
    key: "Bangladesh",
    value: "Bangladesh",
  },
  {
    key: "Russia",
    value: "Russia",
  },
  {
    key: "Japan",
    value: "Japan",
  },
  {
    key: "Mexico",
    value: "Mexico",
  },
  {
    key: "Philippines",
    value: "Philippines",
  },
  {
    key: "Vietnam",
    value: "Vietnam",
  },
  {
    key: "Ethiopia",
    value: "Ethiopia",
  },
  {
    key: "Egypt",
    value: "Egypt",
  },
  {
    key: "Germany",
    value: "Germany",
  },
  {
    key: "Iran",
    value: "Iran",
  },
  {
    key: "Turkey",
    value: "Turkey",
  },
  {
    key: "Democratic Republic of the Congo",
    value: "Democratic Republic of the Congo",
  },
  {
    key: "Thailand",
    value: "Thailand",
  },
  {
    key: "France",
    value: "France",
  },
  {
    key: "United Kingdom",
    value: "United Kingdom",
  },
  {
    key: "Italy",
    value: "Italy",
  },
  {
    key: "Burma",
    value: "Burma",
  },
  {
    key: "South Africa",
    value: "South Africa",
  },
  {
    key: "South Korea",
    value: "South Korea",
  },
  {
    key: "Colombia",
    value: "Colombia",
  },
  {
    key: "Ukraine",
    value: "Ukraine",
  },
  {
    key: "Tanzania",
    value: "Tanzania",
  },
  {
    key: "Kenya",
    value: "Kenya",
  },
  {
    key: "Argentina",
    value: "Argentina",
  },
  {
    key: "Algeria",
    value: "Algeria",
  },
  {
    key: "Poland",
    value: "Poland",
  },
  {
    key: "Sudan",
    value: "Sudan",
  },
  {
    key: "Uganda",
    value: "Uganda",
  },
  {
    key: "Canada",
    value: "Canada",
  },
  {
    key: "Iraq",
    value: "Iraq",
  },
  {
    key: "Morocco",
    value: "Morocco",
  },
  {
    key: "Peru",
    value: "Peru",
  },
  {
    key: "Uzbekistan",
    value: "Uzbekistan",
  },
  {
    key: "Saudi Arabia",
    value: "Saudi Arabia",
  },
  {
    key: "Malaysia",
    value: "Malaysia",
  },
  {
    key: "Venezuela",
    value: "Venezuela",
  },
  {
    key: "Nepal",
    value: "Nepal",
  },
  {
    key: "Afghanistan",
    value: "Afghanistan",
  },
  {
    key: "Yemen",
    value: "Yemen",
  },
  {
    key: "North Korea",
    value: "North Korea",
  },
  {
    key: "Ghana",
    value: "Ghana",
  },
  {
    key: "Mozambique",
    value: "Mozambique",
  },
  {
    key: "Taiwan",
    value: "Taiwan",
  },
  {
    key: "Australia",
    value: "Australia",
  },
  {
    key: "Ivory Coast",
    value: "Ivory Coast",
  },
  {
    key: "Syria",
    value: "Syria",
  },
  {
    key: "Madagascar",
    value: "Madagascar",
  },
  {
    key: "Angola",
    value: "Angola",
  },
  {
    key: "Cameroon",
    value: "Cameroon",
  },
  {
    key: "Sri Lanka",
    value: "Sri Lanka",
  },
  {
    key: "Romania",
    value: "Romania",
  },
  {
    key: "Burkina Faso",
    value: "Burkina Faso",
  },
  {
    key: "Niger",
    value: "Niger",
  },
  {
    key: "Kazakhstan",
    value: "Kazakhstan",
  },
  {
    key: "Netherlands",
    value: "Netherlands",
  },
  {
    key: "Chile",
    value: "Chile",
  },
  {
    key: "Malawi",
    value: "Malawi",
  },
  {
    key: "Ecuador",
    value: "Ecuador",
  },
  {
    key: "Guatemala",
    value: "Guatemala",
  },
  {
    key: "Mali",
    value: "Mali",
  },
  {
    key: "Cambodia",
    value: "Cambodia",
  },
  {
    key: "Senegal",
    value: "Senegal",
  },
  {
    key: "Zambia",
    value: "Zambia",
  },
  {
    key: "Zimbabwe",
    value: "Zimbabwe",
  },
  {
    key: "Chad",
    value: "Chad",
  },
  {
    key: "South Sudan",
    value: "South Sudan",
  },
  {
    key: "Belgium",
    value: "Belgium",
  },
  {
    key: "Cuba",
    value: "Cuba",
  },
  {
    key: "Tunisia",
    value: "Tunisia",
  },
  {
    key: "Guinea",
    value: "Guinea",
  },
  {
    key: "Greece",
    value: "Greece",
  },
  {
    key: "Portugal",
    value: "Portugal",
  },
  {
    key: "Rwanda",
    value: "Rwanda",
  },
  {
    key: "Czech Republic",
    value: "Czech Republic",
  },
  {
    key: "Somalia",
    value: "Somalia",
  },
  {
    key: "Haiti",
    value: "Haiti",
  },
  {
    key: "Benin",
    value: "Benin",
  },
  {
    key: "Burundi",
    value: "Burundi",
  },
  {
    key: "Bolivia",
    value: "Bolivia",
  },
  {
    key: "Hungary",
    value: "Hungary",
  },
  {
    key: "Sweden",
    value: "Sweden",
  },
  {
    key: "Belarus",
    value: "Belarus",
  },
  {
    key: "Dominican Republic",
    value: "Dominican Republic",
  },
  {
    key: "Azerbaijan",
    value: "Azerbaijan",
  },
  {
    key: "Honduras",
    value: "Honduras",
  },
  {
    key: "Austria",
    value: "Austria",
  },
  {
    key: "United Arab Emirates",
    value: "United Arab Emirates",
  },
  {
    key: "Israel",
    value: "Israel",
  },
  {
    key: "Switzerland",
    value: "Switzerland",
  },
  {
    key: "Tajikistan",
    value: "Tajikistan",
  },
  {
    key: "Bulgaria",
    value: "Bulgaria",
  },
  {
    key: "Hong Kong (China)",
    value: "Hong Kong (China)",
  },
  {
    key: "Serbia",
    value: "Serbia",
  },
  {
    key: "Papua New Guinea",
    value: "Papua New Guinea",
  },
  {
    key: "Paraguay",
    value: "Paraguay",
  },
  {
    key: "Laos",
    value: "Laos",
  },
  {
    key: "Jordan",
    value: "Jordan",
  },
  {
    key: "El Salvador",
    value: "El Salvador",
  },
  {
    key: "Eritrea",
    value: "Eritrea",
  },
  {
    key: "Libya",
    value: "Libya",
  },
  {
    key: "Togo",
    value: "Togo",
  },
  {
    key: "Sierra Leone",
    value: "Sierra Leone",
  },
  {
    key: "Nicaragua",
    value: "Nicaragua",
  },
  {
    key: "Kyrgyzstan",
    value: "Kyrgyzstan",
  },
  {
    key: "Denmark",
    value: "Denmark",
  },
  {
    key: "Finland",
    value: "Finland",
  },
  {
    key: "Slovakia",
    value: "Slovakia",
  },
  {
    key: "Singapore",
    value: "Singapore",
  },
  {
    key: "Turkmenistan",
    value: "Turkmenistan",
  },
  {
    key: "Norway",
    value: "Norway",
  },
  {
    key: "Lebanon",
    value: "Lebanon",
  },
  {
    key: "Costa Rica",
    value: "Costa Rica",
  },
  {
    key: "Central African Republic",
    value: "Central African Republic",
  },
  {
    key: "Ireland",
    value: "Ireland",
  },
  {
    key: "Georgia",
    value: "Georgia",
  },
  {
    key: "New Zealand",
    value: "New Zealand",
  },
  {
    key: "Republic of the Congo",
    value: "Republic of the Congo",
  },
  {
    key: "Palestine",
    value: "Palestine",
  },
  {
    key: "Liberia",
    value: "Liberia",
  },
  {
    key: "Croatia",
    value: "Croatia",
  },
  {
    key: "Oman",
    value: "Oman",
  },
  {
    key: "Bosnia and Herzegovina",
    value: "Bosnia and Herzegovina",
  },
  {
    key: "Puerto Rico",
    value: "Puerto Rico",
  },
  {
    key: "Kuwait",
    value: "Kuwait",
  },
  {
    key: "Moldov",
    value: "Moldov",
  },
  {
    key: "Mauritania",
    value: "Mauritania",
  },
  {
    key: "Panama",
    value: "Panama",
  },
  {
    key: "Uruguay",
    value: "Uruguay",
  },
  {
    key: "Armenia",
    value: "Armenia",
  },
  {
    key: "Lithuania",
    value: "Lithuania",
  },
  {
    key: "Albania",
    value: "Albania",
  },
  {
    key: "Mongolia",
    value: "Mongolia",
  },
  {
    key: "Jamaica",
    value: "Jamaica",
  },
  {
    key: "Namibia",
    value: "Namibia",
  },
  {
    key: "Lesotho",
    value: "Lesotho",
  },
  {
    key: "Qatar",
    value: "Qatar",
  },
  {
    key: "Macedonia",
    value: "Macedonia",
  },
  {
    key: "Slovenia",
    value: "Slovenia",
  },
  {
    key: "Botswana",
    value: "Botswana",
  },
  {
    key: "Latvia",
    value: "Latvia",
  },
  {
    key: "Gambia",
    value: "Gambia",
  },
  {
    key: "Kosovo",
    value: "Kosovo",
  },
  {
    key: "Guinea-Bissau",
    value: "Guinea-Bissau",
  },
  {
    key: "Gabon",
    value: "Gabon",
  },
  {
    key: "Equatorial Guinea",
    value: "Equatorial Guinea",
  },
  {
    key: "Trinidad and Tobago",
    value: "Trinidad and Tobago",
  },
  {
    key: "Estonia",
    value: "Estonia",
  },
  {
    key: "Mauritius",
    value: "Mauritius",
  },
  {
    key: "Swaziland",
    value: "Swaziland",
  },
  {
    key: "Bahrain",
    value: "Bahrain",
  },
  {
    key: "Timor-Leste",
    value: "Timor-Leste",
  },
  {
    key: "Djibouti",
    value: "Djibouti",
  },
  {
    key: "Cyprus",
    value: "Cyprus",
  },
  {
    key: "Fiji",
    value: "Fiji",
  },
  {
    key: "Guyana",
    value: "Guyana",
  },
  {
    key: "Comoros",
    value: "Comoros",
  },
  {
    key: "Bhutan",
    value: "Bhutan",
  },
  {
    key: "Montenegro",
    value: "Montenegro",
  },
  {
    key: "Macau (China)",
    value: "Macau (China)",
  },
  {
    key: "Solomon Islands",
    value: "Solomon Islands",
  },
  {
    key: "Western Sahara",
    value: "Western Sahara",
  },
  {
    key: "Luxembourg",
    value: "Luxembourg",
  },
  {
    key: "Suriname",
    value: "Suriname",
  },
  {
    key: "Cape Verde",
    value: "Cape Verde",
  },
  {
    key: "Malta",
    value: "Malta",
  },
  {
    key: "Guadeloupe (France)",
    value: "Guadeloupe (France)",
  },
  {
    key: "Martinique (France)",
    value: "Martinique (France)",
  },
  {
    key: "Brunei",
    value: "Brunei",
  },
  {
    key: "Bahamas",
    value: "Bahamas",
  },
  {
    key: "Iceland",
    value: "Iceland",
  },
  {
    key: "Maldives",
    value: "Maldives",
  },
  {
    key: "Belize",
    value: "Belize",
  },
  {
    key: "Barbados",
    value: "Barbados",
  },
  {
    key: "French Polynesia (France)",
    value: "French Polynesia (France)",
  },
  {
    key: "Vanuatu",
    value: "Vanuatu",
  },
  {
    key: "New Caledonia (France)",
    value: "New Caledonia (France)",
  },
  {
    key: "French Guiana (France)",
    value: "French Guiana (France)",
  },
  {
    key: "Mayotte (France)",
    value: "Mayotte (France)",
  },
  {
    key: "Samoa",
    value: "Samoa",
  },
  {
    key: "Sao Tom and Principe",
    value: "Sao Tom and Principe",
  },
  {
    key: "Saint Lucia",
    value: "Saint Lucia",
  },
  {
    key: "Guam (USA)",
    value: "Guam (USA)",
  },
  {
    key: "Curacao (Netherlands)",
    value: "Curacao (Netherlands)",
  },
  {
    key: "Saint Vincent and the Grenadines",
    value: "Saint Vincent and the Grenadines",
  },
  {
    key: "Kiribati",
    value: "Kiribati",
  },
  {
    key: "United States Virgin Islands (USA)",
    value: "United States Virgin Islands (USA)",
  },
  {
    key: "Grenada",
    value: "Grenada",
  },
  {
    key: "Tonga",
    value: "Tonga",
  },
  {
    key: "Aruba (Netherlands)",
    value: "Aruba (Netherlands)",
  },
  {
    key: "Federated States of Micronesia",
    value: "Federated States of Micronesia",
  },
  {
    key: "Jersey (UK)",
    value: "Jersey (UK)",
  },
  {
    key: "Seychelles",
    value: "Seychelles",
  },
  {
    key: "Antigua and Barbuda",
    value: "Antigua and Barbuda",
  },
  {
    key: "Isle of Man (UK)",
    value: "Isle of Man (UK)",
  },
  {
    key: "Andorra",
    value: "Andorra",
  },
  {
    key: "Dominica",
    value: "Dominica",
  },
  {
    key: "Bermuda (UK)",
    value: "Bermuda (UK)",
  },
  {
    key: "Guernsey (UK)",
    value: "Guernsey (UK)",
  },
  {
    key: "Greenland (Denmark)",
    value: "Greenland (Denmark)",
  },
  {
    key: "Marshall Islands",
    value: "Marshall Islands",
  },
  {
    key: "American Samoa (USA)",
    value: "American Samoa (USA)",
  },
  {
    key: "Cayman Islands (UK)",
    value: "Cayman Islands (UK)",
  },
  {
    key: "Saint Kitts and Nevis",
    value: "Saint Kitts and Nevis",
  },
  {
    key: "Northern Mariana Islands (USA)",
    value: "Northern Mariana Islands (USA)",
  },
  {
    key: "Faroe Islands (Denmark)",
    value: "Faroe Islands (Denmark)",
  },
  {
    key: "Sint Maarten (Netherlands)",
    value: "Sint Maarten (Netherlands)",
  },
  {
    key: "Saint Martin (France)",
    value: "Saint Martin (France)",
  },
  {
    key: "Liechtenstein",
    value: "Liechtenstein",
  },
  {
    key: "Monaco",
    value: "Monaco",
  },
  {
    key: "San Marino",
    value: "San Marino",
  },
  {
    key: "Turks and Caicos Islands (UK)",
    value: "Turks and Caicos Islands (UK)",
  },
  {
    key: "Gibraltar (UK)",
    value: "Gibraltar (UK)",
  },
  {
    key: "British Virgin Islands (UK)",
    value: "British Virgin Islands (UK)",
  },
  {
    key: "Aland Islands (Finland)",
    value: "Aland Islands (Finland)",
  },
  {
    key: "Caribbean Netherlands (Netherlands)",
    value: "Caribbean Netherlands (Netherlands)",
  },
  {
    key: "Palau",
    value: "Palau",
  },
  {
    key: "Cook Islands (NZ)",
    value: "Cook Islands (NZ)",
  },
  {
    key: "Anguilla (UK)",
    value: "Anguilla (UK)",
  },
  {
    key: "Wallis and Futuna (France)",
    value: "Wallis and Futuna (France)",
  },
  {
    key: "Tuvalu",
    value: "Tuvalu",
  },
  {
    key: "Nauru",
    value: "Nauru",
  },
  {
    key: "Saint Barthelemy (France)",
    value: "Saint Barthelemy (France)",
  },
  {
    key: "Saint Pierre and Miquelon (France)",
    value: "Saint Pierre and Miquelon (France)",
  },
  {
    key: "Montserrat (UK)",
    value: "Montserrat (UK)",
  },
  {
    key: "Saint Helena, Ascension and Tristan da Cunha (UK)",
    value: "Saint Helena, Ascension and Tristan da Cunha (UK)",
  },
  {
    key: "Svalbard and Jan Mayen (Norway)",
    value: "Svalbard and Jan Mayen (Norway)",
  },
  {
    key: "Falkland Islands (UK)",
    value: "Falkland Islands (UK)",
  },
  {
    key: "Norfolk Island (Australia)",
    value: "Norfolk Island (Australia)",
  },
  {
    key: "Christmas Island (Australia)",
    value: "Christmas Island (Australia)",
  },
  {
    key: "Niue (NZ)",
    value: "Niue (NZ)",
  },
  {
    key: "Tokelau (NZ)",
    value: "Tokelau (NZ)",
  },
  {
    key: "Vatican",
    value: "Vatican",
  },
  {
    key: "Cocos (Keeling) Islands (Australia)",
    value: "Cocos (Keeling) Islands (Australia)",
  },
  {
    key: "Pitcairn Islands (UK)",
    value: "Pitcairn Islands (UK)",
  },
];
